export const SEEKER_ONLY_LAUNCH = true;

export const DEFAULT_SEEKER_ONBOARDING_INTENT = 'job' as const;

// Employer Phase 1 (Company Page + Applications) staged rollout. Fail-closed:
// employer-only navigation and surfaces stay hidden unless the build opts in.
// The server enforces its own EMPLOYER_PHASE1_ENABLED gate independently.
export const EMPLOYER_PHASE1 =
  process.env.EXPO_PUBLIC_EMPLOYER_PHASE1 === 'true';

// Company workspaces become reachable when the seeker-only launch ends OR the
// Employer Phase 1 build flag opts in. Consumers that gate workspace surfaces
// read this derived flag; onboarding stays keyed to SEEKER_ONLY_LAUNCH.
export const EMPLOYER_WORKSPACES_ENABLED = !SEEKER_ONLY_LAUNCH || EMPLOYER_PHASE1;

// Employer-shell rows that ship after the Company Page (Find Talent, Analytics,
// Jobs). Hidden by default in Phase 1; a build opts in explicitly.
export const EMPLOYER_EXTRA_NAV =
  process.env.EXPO_PUBLIC_EMPLOYER_EXTRA_NAV === 'true';

/**
 * Developer platform client surfaces: the "Sign in with Tabbio" consent screen
 * and Settings > Connected apps. Registering an app lives in the developer
 * platform app (platform.tabbio.com), not here.
 *
 * Mirrors the API's own `DEVELOPER_PLATFORM_ENABLED`: fail closed in a
 * production build so a release that forgets the variable ships the surface
 * dark rather than half-wired, on everywhere else so development, CI and
 * internal builds exercise it without extra setup. `EXPO_PUBLIC_*` is inlined
 * at build time, so this is a build-time decision, not a runtime one.
 *
 * Exported as a function as well as a constant because the constant is frozen
 * at module load, which a test cannot re-enter.
 */
export function resolveDeveloperPlatformEnabled(
  raw: string | undefined = process.env.EXPO_PUBLIC_DEVELOPER_PLATFORM_ENABLED,
  // `typeof` guard: __DEV__ is a React Native global that does not exist under
  // the plain-node test environment.
  isDevBuild: boolean = typeof __DEV__ !== 'undefined' && __DEV__,
  nodeEnv: string | undefined = process.env.NODE_ENV,
) {
  const configured = raw?.trim();

  if (configured) {
    return configured.toLowerCase() === 'true';
  }

  return isDevBuild || nodeEnv !== 'production';
}

export const DEVELOPER_PLATFORM_ENABLED = resolveDeveloperPlatformEnabled();
